import React, { useState } from "react";
import { Outlet, Link } from "react-router-dom";
import "./Layout.css";

function Layout({ user, onLogout }) {
  // Inicialmente, el menú estará abierto en desktop
  const [menuAbierto, setMenuAbierto] = useState(true);

  const toggleMenu = () => {
    setMenuAbierto(!menuAbierto);
  };

  return (
    <div className={`layout ${menuAbierto ? "menu-abierto" : "menu-cerrado"}`}>
      {/* Header fijo */}
      <header className="header">
        <div className="left-section">
          <button className="hamburger-btn" onClick={toggleMenu}>☰</button>
          <span className="titulo">Gestión de Alarmas</span>
        </div>

        <div className="header-center">
          <img src="/logo.png" alt="Logo" className="logopng" />
        </div>

        <div className="user-info">
          {user && (
            <>
              <span>User: {user}</span>
              <button className="logout-btn" onClick={onLogout}>Cerrar Sesión</button>
            </>
          )}
        </div>
      </header>

      <div className="container">
        {/* Sidebar: se oculta o muestra según el estado */}
        <nav className={`sidebar ${menuAbierto ? "abierto" : "cerrado"}`}>
          <ul>
            <li>Menú General</li>
            <li><Link to=""> 🖥️ HMI</Link></li>
            <li><Link to="/Panel"> 🚨 Alarmas Activas</Link></li>
            <li><Link to="/dashboard"> 📊 Dashboard</Link></li>
            <li>________________</li>
            <li><Link to="/contactos">👥 Contactos</Link></li>
            <li><Link to="/Listado-alarmas">📢 Alarmas</Link></li>
            <li><Link to="/contactos-generales">🧑‍🚒 Contactos Alarmas</Link></li>
            <li>________________</li>
            <li><Link to="/historial-llamadas">☎️ Historial Llamadas</Link></li>
            <li><Link to="/log-alarmas">🧾 Log de Alarmas</Link></li>
          </ul>
        </nav>

        {/* Contenido principal */}
        <main className="content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}

export default Layout;
